"use client";

import {useTransition} from "react";
import {useRouter} from "next/navigation";
import {Button} from "@repo/ui/components/button";

import styles from "./DisableDraftMode.module.css";

interface Props {
	disableDraftMode: () => Promise<void>;
}

export function DisableDraftMode({disableDraftMode}: Props) {
	const router = useRouter();
	const [pending, startTransition] = useTransition();

	// Only show the disable draft mode button when outside of Presentation Tool

	// TODO: This environment variable is always "checking" right now, so just ignoring it and
	// showing the button during draft mode regardless of environment.
	// Support Thread: https://sanity-io.slack.com/archives/C09EWG07X63/p1759958348104419
	// console.log("environment", environment);
	// if (environment !== "live" && environment !== "unknown") {
	// 	return null;
	// }

	const disable = () =>
		startTransition(async () => {
			await disableDraftMode();
			router.refresh();
		});

	return (
		<div className={styles.wrapper}>
			{pending ? (
				"Disabling draft mode..."
			) : (
				<Button type="button" onClick={disable}>
					Disable draft mode
				</Button>
			)}
		</div>
	);
}
